/**
 * governance/utils.ts
 * Barrel re-export — all governance utilities.
 *
 * Split into focused modules (FIX-4, P1-S1):
 *   utils/severity.ts         — severity types, ordering, helpers
 *   utils/contentPatterns.ts   — generic text detection, didactic checks, module patterns
 *   utils/tierRequirements.ts  — tier-aware minimum content requirements
 *   utils/issueSummary.ts      — issue aggregation and quality scoring
 *   utils/languageQuality.ts   — jargon, passive voice, sentence length
 *
 * Public API is 100% identical — no consumer changes needed.
 */

// ─── Severity ─────────────────────────────────────────────────────────────────
export {
  type SeverityLevel,
  SEVERITY_ORDER,
  compareSeverity,
  isBlockingSeverity,
  severityLabel,
  severityColor,
  SEVERITY_WEIGHTS,
  normalizeSeverity,
} from './utils/severity'

// ─── Content Patterns ─────────────────────────────────────────────────────────
export {
  NON_MC_TYPES,
  CHECK_STRATEGY_PATTERN,
  TOPO_GEOGRAPHIC_DEPTH_PATTERN,
  GENERIC_EXPLANATION_PATTERNS,
  GENERIC_DISTRACTOR_PATTERNS,
  FORBIDDEN_OPENER_PATTERNS,
  GET_MISCONCEPTIONS,
  SWW_RULES,
  SWW_CHECK_STRATEGY,
  SPR_RULES,
  MET_FORMULA,
  TGL_CALC,
  TGL_ERRORS,
  TAA_CITE,
  STU_STRATEGY,
  isGenericText,
  isDidactic,
  isSubstantiveExplanation,
  hasModuleSpecificDepth,
} from './utils/contentPatterns'

// ─── Issue Summary ────────────────────────────────────────────────────────────
export {
  type IssueSummary,
  summarizeIssues,
  computeQualityScore,
} from './utils/issueSummary'

// ─── Language Quality ─────────────────────────────────────────────────────────
export {
  JARGON_PATTERNS,
  PASSIVE_VOICE_PATTERNS,
  getMaxWordsPerSentence,
  detectLongSentences,
  detectJargon,
  hasPassiveVoice,
} from './utils/languageQuality'
